import { Action } from '@ngrx/store';
import { AccesoAplicacionMarkable, AccesoDate, MFTokenPersona, PortalAuditorToken } from 'src/common/acceso';
import { AplicacionPerfilId } from 'src/common/managedLinkTypes';

export const URL_NOT_FOUND: string = 'NOT_FOUND';
export const CANT_CREATE_TOKEN: string = 'CANT_CREATE_TOKEN';
export const CANT_GET_ACCESO_DATE: string = 'CANT_GET_ACCESO_DATE';
export const CANT_GET_IP_CLIENTE: string = 'CANT_GET_IP_CLIENTE';

export enum AplicacionActionTypes {
    AllAplicacionRequested = '[Base Component] All Aplicacion Requested',
    AllAplicacionLoaded = '[Aplicacion API] All Aplicacion Loaded',
	AllAplicacionCancelled = '[Aplicacion API] All Aplicacion Cancelled',
	AllAplicacionRight = '[Aplicacion API] All Aplicacion Right',
	AplicacionToggleMarkedRequested = '[Aplicacion Component] Aplicacion Toggle Marked Requested',
	AplicacionToggleMarkedLoaded = '[Aplicacion API] Aplicacion Toggle Marked Loaded',
	AplicacionToggleMarkedCancelled = '[Aplicacion API] Aplicacion Toggle Marked Cancelled',
	AplicacionFavInit = '[MainApp Component] Aplicacion Fav Init',

	// Acceso related actions
	AccesoUrlRequested = '[ManagedLink] Acceso Url Requested',
	AccesoUrlLoaded = '[Acceso API] Acceso Url Loaded',
	AccesoUrlCancelled = '[Acceso API] Acceso Url Cancelled',

	MFTokenPersonaRequested = '[ManagedLink] MF Token Persona Requested',
	MFTokenPersonaLoaded = '[Acceso API] MF Token Persona Loaded',
	MFTokenPersonaCancelled = '[Acceso API] MF Token Persona Cancelled',

	AccesoDateRequested = "[ManagedLink] Acceso Date Requested",
	AccesoDateLoaded = "[Acceso API] Acceso Date Loaded",
	AccesoDateCancelled = "[Acceso API] Acceso Date Cancelled",

	PortalAuditorTokenRequested = '[Acceso API] Portal Auditor Token Requested',
	PortalAuditorTokenLoaded = '[Acceso API] Portal Auditor Token Loaded',
	PortalAuditorTokenCancelled = '[Acceso API] Portal Auditor Token Cancelled',

	IpClienteRequested = '[ManagedLink] Ip Cliente Requested',
	IpClienteLoaded = '[Acceso API] Ip Cliente Loaded',
	IpClienteCancelled = '[Acceso API] Ip Cliente Cancelled',

	HCETokenRequested = '[ManagedLink] HCE Token Requested',
	HCETokenLoaded = '[Acceso API] HCE Token Loaded',
	HCETokenCancelled = '[Acceso API] HCE Token Cancelled',

	CredTokenRequested = '[ManagedLink] Cred Token Requested',
	CredTokenLoaded = '[Acceso API] Cred Token Loaded',
	CredTokenCancelled = '[Acceso API] Cred Token Cancelled'
}

export class AllAplicacionRequested implements Action {
	readonly type: string = AplicacionActionTypes.AllAplicacionRequested;
	constructor( public payload: { forceReload: boolean } ) {
	}
}

export class AllAplicacionLoaded implements Action {
	readonly type: string = AplicacionActionTypes.AllAplicacionLoaded;
	constructor( public payload: { accesos: AccesoAplicacionMarkable[], ipCliente: string } ) {
	}
}

export class AllAplicacionCancelled implements Action {
	readonly type: string = AplicacionActionTypes.AllAplicacionCancelled;
	constructor() {
	}
}

export class AllAplicacionRight implements Action {
	readonly type: string = AplicacionActionTypes.AllAplicacionRight;
	constructor() {
	}
}

export class AplicacionToggleMarkedRequested implements Action {
	readonly type: string = AplicacionActionTypes.AplicacionToggleMarkedRequested;
	constructor( public payload: AccesoAplicacionMarkable ) {
	}
}

export class AplicacionToggleMarkedLoaded implements Action {
	readonly type: string = AplicacionActionTypes.AplicacionToggleMarkedLoaded;
	constructor( public payload: number ) {
	}
}

export class AplicacionToggleMarkedCancelled implements Action {
	readonly type: string = AplicacionActionTypes.AplicacionToggleMarkedCancelled;
	constructor( public payload: number ) {
	}
}

export class AplicacionFavInit implements Action {
	readonly type: string = AplicacionActionTypes.AplicacionFavInit;
	constructor() {
	}
}


// Acceso related actions
export class AccesoUrlRequested implements Action {
	readonly type: string = AplicacionActionTypes.AccesoUrlRequested;
	constructor( public payload: AplicacionPerfilId ) {
	}
}

export class AccesoUrlLoaded implements Action {
	readonly type: string = AplicacionActionTypes.AccesoUrlLoaded;
	constructor( public payload: { url: string } ) {
	}
}

export class AccesoUrlCancelled implements Action {
	readonly type: string = AplicacionActionTypes.AccesoUrlCancelled;
	constructor() {
	}
}

export class MFTokenPersonaRequested implements Action {
	readonly type: string = AplicacionActionTypes.MFTokenPersonaRequested;
	constructor( public payload: { nombreAplicacion: string, nombreAplicacionPerfil: string } ) {
	}
}

export class MFTokenPersonaLoaded implements Action {
	readonly type: string = AplicacionActionTypes.MFTokenPersonaLoaded;
	constructor( public payload: MFTokenPersona ) {
	}
}

export class MFTokenPersonaCancelled implements Action {
	readonly type: string = AplicacionActionTypes.MFTokenPersonaCancelled;
	constructor() {
	}
}

export class AccesoDateRequested implements Action {
	readonly type: string = AplicacionActionTypes.AccesoDateRequested;
	constructor() {
	}
}

export class AccesoDateLoaded implements Action {
	readonly type: string = AplicacionActionTypes.AccesoDateLoaded;
	constructor( public payload: AccesoDate ) {
	}
}

export class AccesoDateCancelled implements Action {
	readonly type: string = AplicacionActionTypes.AccesoDateCancelled;
	constructor() {
	}
}

export class PortalAuditorTokenRequested implements Action {
	readonly type: string = AplicacionActionTypes.PortalAuditorTokenRequested;
	constructor( public payload: { idPersonaFederada: number } ) {
	}
}

export class PortalAuditorTokenLoaded implements Action {
	readonly type: string = AplicacionActionTypes.PortalAuditorTokenLoaded;
	constructor( public payload: PortalAuditorToken ) {
	}
}

export class PortalAuditorTokenCancelled implements Action {
	readonly type: string = AplicacionActionTypes.PortalAuditorTokenCancelled;
	constructor() {
	}
}

export class IpClienteRequested implements Action {
	readonly type: string = AplicacionActionTypes.IpClienteRequested;
	constructor() {
	}
}

export class IpClienteLoaded implements Action {
	readonly type: string = AplicacionActionTypes.IpClienteLoaded;
	constructor( public payload: { ipCliente: string } ) {
	}
}

export class IpClienteCancelled implements Action {
	readonly type: string = AplicacionActionTypes.IpClienteCancelled;
	constructor() {
	}
}

export class HCETokenRequested implements Action {
	readonly type: string = AplicacionActionTypes.HCETokenRequested;
	constructor() {
	}
}

export class HCETokenLoaded implements Action {
	readonly type: string = AplicacionActionTypes.HCETokenLoaded;
	constructor( public payload: { token: string } ) {
	}
}

export class HCETokenCancelled implements Action {
	readonly type: string = AplicacionActionTypes.HCETokenCancelled;
	constructor() {
	}
}

// Cred Token related actions
export class CredTokenRequested implements Action {
	readonly type: string = AplicacionActionTypes.CredTokenRequested;
	constructor( public payload: { ne: string, ce: string } ) {
	}
}

export class CredTokenLoaded implements Action {
	readonly type: string = AplicacionActionTypes.CredTokenLoaded;
	constructor( public payload: { token: string } ) {
	}
}

export class CredTokenCancelled implements Action {
	readonly type: string = AplicacionActionTypes.CredTokenCancelled;
	constructor() {
	}
}

export type AplicacionActions = AllAplicacionRequested | AllAplicacionLoaded | AllAplicacionCancelled |
	AplicacionToggleMarkedRequested | AplicacionToggleMarkedLoaded |
	AccesoUrlRequested | AccesoUrlLoaded | AccesoUrlCancelled |
	MFTokenPersonaRequested | MFTokenPersonaLoaded | MFTokenPersonaCancelled |
	AccesoDateRequested | AccesoDateLoaded | AccesoDateCancelled |
	PortalAuditorTokenRequested | PortalAuditorTokenLoaded | PortalAuditorTokenCancelled |
	IpClienteRequested | IpClienteLoaded | IpClienteCancelled |
	HCETokenRequested | HCETokenLoaded | HCETokenCancelled | 
	CredTokenRequested | CredTokenLoaded | CredTokenCancelled;